<template>
    <div class="install-app-guide">
        <p class="title">{{ $t('share.installGuide.title') }}</p>
        <p class="des">{{ $t('share.installGuide.des') }}</p>
        <ul class="step-content">
            <li class="step-box">
                <p class="step-num">{{ $t('share.installGuide.stepOne.stepNum') }}</p>
                <p class="step-des">{{ $t('share.installGuide.stepOne.stepDes') }}</p>
                <a :href="step1Url">{{ $t('share.installGuide.stepOne.button') }}</a>
            </li>
            <li class="step-box">
                <p class="step-num">{{ $t('share.installGuide.stepTwo.stepNum') }}</p>
                <p class="step-des">{{ $t('share.installGuide.stepTwo.stepDes') }}</p>
                <img :src="step2Pic" alt="">
            </li>
        </ul>
    </div>
</template>
<script>
import step2Pic from '@/common/images/oem/reolink-cn/share/step02_pic.png';
import { config } from 'CONFIG';

export default {
    data () {

        return {
            step1Url: '',
            step2Pic
        };
    
    },
    created () {

        if ( config.client === 'IOS' ) {

            this.step1Url = 'https://apps.apple.com/cn/app/reolink/id1473096889';

        } else {
            
            this.step1Url = 'https://reolink.com.cn/software-download/';
            
        }

    }
};
</script>
<style lang="less" scoped>
    .install-app-guide {
        padding: .6rem .5rem;
        text-align: center;
        box-sizing: border-box;
        .title {
            font-size: .46rem;
            font-weight: 700;
            color: #333;
        }
        .des {
            font-size: .34rem;
            font-weight: 400;
            color: #777;
            margin-top: .2rem;
        }
        .step-content {
            margin-top: .6rem;
            .step-box {
                padding: .3rem .3rem 0;
                background-color: #F7F8F9;
                border-radius: .24rem;
                text-align: left;
                .step-num {
                    font-size: .34rem;
                    font-weight: 700;
                    color: #333;
                }
                .step-des {
                    font-size: .26rem;
                    font-weight: 400;
                    color: #777;
                    margin-top: .1rem;
                }
                a {
                    display: inline-block;
                    width: 100%;
                    border-radius: .42rem;
                    background: linear-gradient(150deg,#1E7FEF,#1DC1E1);
                    line-height: .88rem;
                    font-size: .34rem;
                    font-weight: 700;
                    color: #fff;
                    text-align: center;
                    margin: .6rem 0;
                }
                img {
                    display: inline-block;
                    width: 100%;
                    margin: .4rem 0;
                }
                & + .step-box {
                    margin-top: .3rem;
                }
            }
        }
    }
</style>



// WEBPACK FOOTER //
// src/view/share/installGuide.vue